import React from 'react';
import PropTypes from 'prop-types';
import { getImageUrl } from '../../utils';

import {
  ContentSection,
  Wrapper,
  FieldSet,
  FieldSetLabel,
  List,
  ListItem,
  ColumnWrapper,
  UserImage,
  UserName,
} from './styles';

const CollaboratorSection = ({ options, fileService, collaborators = [], isSession, translations }) => {
  const { inReview } = options;

  const appTexts = translations.app;

  const collaboratorSorter = (a, b) => {
    const getKey = (item) => {
      const { full_name } = item.User || item;
      return `${full_name}`;
    };
    return getKey(a).localeCompare(getKey(b));
  };

  return (
    <ContentSection>
      {!inReview && (
        <FieldSet>
          <FieldSetLabel>{isSession ? appTexts.teachers : appTexts.collaborators}</FieldSetLabel>
          <List>
            <ColumnWrapper>
              {collaborators.sort(collaboratorSorter).map((item) => {
                const { uuid, full_name, image, id } = item.User || item;
                const imageUrl = getImageUrl(fileService, image, '25x25');
                return (
                  <ListItem key={uuid || id}>
                    <Wrapper>
                      <UserImage src={imageUrl} />
                      <UserName>{full_name}</UserName>
                    </Wrapper>
                  </ListItem>
                );
              })}
            </ColumnWrapper>
          </List>
        </FieldSet>
      )}
    </ContentSection>
  );
};

export default CollaboratorSection;

CollaboratorSection.propTypes = {
  options: PropTypes.object.isRequired,
  fileService: PropTypes.object.isRequired,
  collaborators: PropTypes.array.isRequired,
  isSession: PropTypes.bool.isRequired,
  translations: PropTypes.object.isRequired,
};
